<template>
  <o-dialog
    ref="dialog"
    :title="$t('reservation.checkInCustomer')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('reservation.confirmCheckIn'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  >
    <div v-if="reservation && !hasSale" class="pt-4 text-left space-y-4">
      <div>
        <div>
          <p class="opacity-90 text-sm" leading-none>
            {{ service ? service.title : reservation.service.title }}
          </p>
          <p class="opacity-70 text-xs leading-none mb-1">
            {{ employee ? employee.displayName : reservation.employee.displayName }}
          </p>
        </div>

        <discount-select
          v-if="options.availableCustomerPasses"
          :service="service || reservation.service"
          :employee="employee || reservation.employee"
          v-model:customerPass="customerPass"
          :customerPasses="options.availableCustomerPasses"
          :placeholder="$t('pass.select')"
          class="w-full"
        />
      </div>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import DiscountSelect from '@/components/reservation/elements/DiscountSelect.vue'

interface Props {
  reservation?: Record<string, any> | null
  service?: Record<string, any> | null
  employee?: Record<string, any> | null
  portal?: string | null
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  reservation: null,
  service: null,
  employee: null,
  portal: null,
  loading: false,
})

const emit = defineEmits<{
  'update:loading': [value: boolean]
  'update:reservation': [value: any]
  'update': []
}>()

const { $api, $notification, $bus, $i18n } = useNuxtApp()

const dialog = ref<any>(null)

const customerPass = ref<any>(null)

const info = computed(() => {
  return $i18n.t('components.reservationCustomer.actions.checkIn.info', { name: props.reservation?.customer.displayName })
})

const options = computed(() => {
  return props.reservation?.options
})

const hasSale = computed(() => {
  return !!props.reservation?.order
})

function open() {
  dialog.value.open()

  customerPass.value = props.reservation!.customerPass
}

async function confirm() {
  emit('update:loading', true)

  const findPass = 0
  const customerPassVal = customerPass.value

  try {
    const reservationCustomerId = props.reservation?.idReservationCustomer?.toString()
    const customerPassId = customerPassVal?.idCustomerPass?.toString()
    const response = await $api.reservationCustomer.checkIn(reservationCustomerId, { findPass: !!findPass, customerPassId })
    const reservation = response.data

    if (reservation) {
      emit('update:reservation', reservation)
      emit('update:loading', false)
      emit('update')

      $bus.emit.updated('Reservation', reservation)

      $notification.toast({
        title: $i18n.t('reservation.checkedIn'),
        text: $i18n.t('components.reservationCustomer.actions.checkIn.successInfo', { name: props.reservation!.customer.displayName }),
        variant: 'success',
      })

      return true
    }
  } catch (e) {
    console.log(e)
  }
}

defineExpose({ open })
</script>
